import { Skeleton } from "@mui/material";

export const SkeletonSelectedBinCard = () => {
  return (
    <div className="selected-bin-container-card-skeleton  mb-2">
      <Skeleton sx={{ width: "100%", height: "100%" }} variant="rectangular" />
    </div>
  );
};

export const SkeletonValues = () => {
  return (
    <div className="selected-bin-container-info-skeleton mt-2">
      <Skeleton sx={{ width: "100%", height: "100%" }} variant="rectangular" />
    </div>
  );
};

export const SkeletonListLayout = () => {
  return (
    <Skeleton sx={{ width: "100%", height: "100%" }} height={40} variant="rectangular" />
  );
};
